<div class="expansion-panel">
  <button class="expansion-panel-header"
    (click)="toggle()"
    [attr.aria-expanded]="isExpanded()">
    <div class="panel-title">
      @if (icon) {
        <fw-icon color="primary" size="medium">{{icon}}</fw-icon>
      }
      {{ title }}
    </div>
    <fw-icon class="expand-icon"
      [class.expanded]="isExpanded()"
      size="small">
      {{ isExpanded() ? 'chevron-up' : 'chevron-down' }}
    </fw-icon>
  </button>

  <div class="expansion-panel-content"
    [@expandCollapse]="isExpanded()">
    <div class="content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
